import React from 'react';

import {HoistedTag} from 'inventory/InventoryFileConstants';
import {SchemaFieldPath} from 'schemas/fields/SchemaFieldConstants';

// @ts-expect-error
import HoistedTagNameBadge from './HoistedTagNameBadge';

interface HoistedTagNameCellProps {
  tag: HoistedTag;
  tagSchemaGraph: SchemaFieldPath;
}

export default function HoistedTagNameCell(props: HoistedTagNameCellProps): JSX.Element {
  return (
    <div className="metadata-field-row">
      <div className="metadata-field-col">
        <div>
          <span className="u-mini-spacing-right">{props.tag.name}</span>
          <HoistedTagNameBadge tagSchemaGraph={props.tagSchemaGraph} />
        </div>
      </div>
    </div>
  );
}
